import React, { useEffect, useState } from 'react';
import { ILegaltransactionNote } from '../../Interfaces/ILegaltransactionNote';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { castWithZeroTimezone } from '../../core/generic_helper';
import { Delete } from '@mui/icons-material';
import { CustomeTextField } from '../../generic/CustomeTextField';

interface IProps {
  note: ILegaltransactionNote;
  noteArray: ILegaltransactionNote[];
  setNoteArray: Function;
}

export const NoteRow: React.FC<IProps> = ({
  note,
  noteArray,
  setNoteArray,
}) => {
  const [editNote, setEditNote] = useState(note);

  const onRemove = () => {
    setNoteArray([
      ...noteArray.filter(
        x => x.idLegalTransactionNote !== editNote.idLegalTransactionNote
      ),
    ]);
  };

  useEffect(() => {
    setNoteArray([
      ...noteArray.map(x =>
        x.idLegalTransactionNote === editNote.idLegalTransactionNote
          ? editNote
          : x
      ),
    ]);
  }, [editNote]);

  if (note.idLegalTransactionNote > 0) {
    return (
      <TableRow>
        <TableCell>
          {castWithZeroTimezone(String(note.Created_at)).toLocaleString()}
        </TableCell>
        <TableCell>
          {note.FirstName} {note.LastName}
        </TableCell>
        <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
          {note.Note}
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
    );
  } else {
  }

  return (
    <TableRow>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
        <CustomeTextField
          label='Notiz'
          attr='Note'
          object={editNote}
          setObject={setEditNote}
          type='string'
          rows={3}
        />
      </TableCell>

      <TableCell>
        <IconButton onClick={onRemove}>
          <Delete />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
